function e(e, r) {
  var t = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var n = 0;
    for (o = Object.getOwnPropertySymbols(e); n < o.length; n++) r.indexOf(o[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[n]) && (t[o[n]] = e[o[n]]);
  }
  return t;
}
function r(e, r) {
  return Object.defineProperty ? Object.defineProperty(e, "raw", {
    value: r
  }) : e.raw = r, e;
}
"function" == typeof SuppressedError && SuppressedError;
export { r as __makeTemplateObject, e as __rest };